import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import COLORS from '@mlb/react-patterns/style/universal.color';
import { media } from '@mlb/react-patterns/style/helpers/media.ts';

import { Tracking } from 'bdvp-tracking';

export const Label = styled.label`
    cursor: pointer;
    user-select: none;
    line-height: 0;
    width: 102px;
    display: inline-block;
    margin: 0 7.5px;

    &:after {
        content: '';
        display: block;
        margin: 10px auto;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: ${COLORS.mlbGrey6};
    }

    ${media.mdmin`
        margin: 0 8px;
        width: 123px;
    `}
`;

const Img = styled.img`
    border-radius: 6px;
`;

// Hide radio visually but remain accessible to screen readers.
export const HiddenRadio = styled.input.attrs({
    type: 'radio',
})`
    border: 0;
    clip: rect(0 0 0 0);
    clippath: inset(50%);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    white-space: nowrap;
    width: 1px;
    &:checked + ${Label} {
        &:after {
            background-color: ${COLORS.liveYellow};
        }
        ${Img} {
            border: 2px solid ${COLORS.mlbWhite};
        }
    }
    body:not(.using-mouse) &:focus + ${Label} {
        outline: 2px solid ${COLORS.tabFocusColor};
        border-radius: 6px;
    }
`;

const thumbnailFormatInstructions = 'ar_16:9,g_auto,q_auto:good,w_120,c_fill,f_jpg';
const retina = [
    {
        dpr: '2x',
        instruction: `${thumbnailFormatInstructions},dpr_2.0`,
    },
    {
        dpr: '3x',
        instruction: `${thumbnailFormatInstructions},dpr_3.0`,
    },
];

const ThumbnailRadio = (props) => {

    const {
        handleChange,
        clip,
        formState,
    } = props;

    const checked = clip.thumbnailUrl === formState.thumbnailUrl;

    return (
        <>
            <HiddenRadio
                id={clip.mediaId}
                name={'thumbnailUrl'}
                value={clip.thumbnailUrl}
                checked={checked}
                onChange={handleChange}
            />
            <Label
                htmlFor={clip.mediaId}
                value={clip.title}
                onClick={() => {

                    Tracking.trackReelCreationFormThumbnailClick();

                }}>
                <Img
                    src={clip.thumbnailUrl.replace('{formatInstructions}', thumbnailFormatInstructions)}
                    srcSet={retina.map((val) => (
                        `${clip.thumbnailUrl.replace('{formatInstructions}', `${val.instruction}`)} ${val.dpr}`
                    )).join(', ')}
                    width={'100%'}
                    alt={clip.title}
                />
            </Label>
        </>
    );

};

ThumbnailRadio.propTypes = {
    handleChange: PropTypes.func.isRequired,
    clip: PropTypes.object.isRequired,
    formState: PropTypes.object.isRequired,
};

export default ThumbnailRadio;
